import jwtDecode from 'jwt-decode';

export const getJTI = (acccessToken) => {
	try {
		const decoded = jwtDecode(acccessToken);

		return decoded
			? decoded.jti
			: null;
	} catch (e) {
		return null;
	}
};